const get_started = {
    page_title: 'Commencer',
    title: 'Quelque chose à explorer pour vous aider à réussir',
    subtitle: 'Quelques choses que vous pouvez faire pour obtenir rapidement de la valeur de Logto',
    develop: {
        title: 'Développer: Prenez 5 minutes pour intégrer votre application',
        title_cloud: 'Développer: Intégrez votre application de manière sécurisée en quelques minutes',
        subtitle_cloud: 'Ou prenez 5 minutes pour intégrer votre application avec nos SDK préconstruits et tutoriels.',
        try_mcp: "Essayez l'intégration en une seule invite avec MCP",
    },
    customize: {
        title: 'Personnaliser: Offrez une excellente expérience de connexion',
        preview: {
            title: "Vérifiez l'aperçu en direct de l'expérience de connexion que vous venez de personnaliser",
            subtitle: "Essayez dès maintenant l'expérience de connexion de Logto pour voir comment cela fonctionne",
        },
        connector: {
            title: 'Ajoutez plus de connecteurs pour prendre en charge plus de méthodes de connexion social',
            subtitle: 'Essayez la connexion sans mot de passe et activez une expérience sécurisée et sans friction pour vos clients',
        },
        continue_customizing: 'Continuer la personnalisation',
        try_now: 'Essayez maintenant',
        add_more: 'Ajouter plus',
    },
    secure: {
        title: 'Sécurité: Protégez vos ressources',
    },
    manage: {
        title: "Gérer: Définir le contrôle d'accès pour votre produit et vos utilisateurs",
        rbac: {
            title: "Ajoutez un contrôle d'accès basé sur les rôles pour protéger vos ressources",
            subtitle: "Contrôlez vos ressources grâce à une autorisation de rôle évolutive pour des cas d'utilisation divers",
        },
        create_roles: 'Créer des rôles',
    },
    convert_to_production: {
        card_title: "Prêt à passer en direct? N'oubliez pas de lancer votre configuration de production!",
        title: 'Ne laissez pas votre projet bloqué en mode dev',
        subtitle: 'Vous utilisez un locataire de développement pour les tests gratuits. Pour passer en direct, créez ou convertissez en un locataire de production. Besoin de quelque chose de personnalisé? <a>Contactez-nous</a>',
        convert_button: 'Convertir en locataire de production',
    },
    oss_cloud: {
        try: {
            title: 'Évitez le travail d’exploitation et essayez Logto Cloud gratuitement',
            badge: 'Recommandé',
            description: 'Profitez d’un Logto entièrement géré sans maintenance, avec en plus une intégration rapide via MCP, la prise en charge du multi-tenant, la collaboration d’équipe et toutes les fonctionnalités premium incluses. Commencez gratuitement, sans carte bancaire.',
            action: 'Explorer Logto Cloud',
        },
        private_cloud: {
            title: 'Besoin de conformité ou d’un déploiement personnalisé ?',
            card_title: 'Cloud privé',
            description: 'Obtenez une instance Logto dédiée avec isolation complète des données, domaine personnalisé et garanties SLA. Idéal pour les entreprises ayant des exigences strictes en matière de résidence des données ou de conformité. Nous gérons l’infrastructure pour que vous puissiez vous concentrer sur votre produit.',
        },
        sidebar: {
            title: 'Concentrez-vous sur le développement, pas sur l’hébergement.',
            description: 'Laissez Logto Cloud gérer l’infrastructure d’authentification pour vous.',
            action: 'Essayer Logto Cloud',
        },
    },
    view_all: 'Tout afficher →',
};
export default Object.freeze(get_started);
